export default __webpack_public_path__ + "static/media/banner2.0a973325.jpeg";